import { StyleProp, ViewStyle } from "react-native";
import { ShareDownloadDataType, useShareDownload } from "src/components/ShareMenu";
import IconDownload from "src/icons/IconDownload";
import FloatingActionItem from "./FloatingActionItem";

const FloatingDownloadButton = ({
	data,
	containerStyle,
}: {
	data: ShareDownloadDataType;
	containerStyle?: StyleProp<ViewStyle>;
}) => {
	const { handlePress, loading } = useShareDownload();

	return (
		<FloatingActionItem
			loading={loading}
			Icon={IconDownload}
			onPress={() => handlePress(data)}
			containerStyle={containerStyle}
			testID="Select-Download"
		/>
	);
};
export default FloatingDownloadButton;
